import React, { useState } from 'react';
import PieChart from './PieChart';
import EmptyState from 'app/components/EmptyState';
import { FiChevronDown } from 'react-icons/fi';

export default function PieChartWidget({ data = [], filters, institutions }) {
  const [sortDirection, setSortDirection] = useState('desc');

  const sorted = [...data].sort((a, b) => {
    if (sortDirection === 'asc') {
      return a['total_users'] - b['total_users'];
    } else {
      return b['total_users'] - a['total_users'];
    }
  });

  return (
    <>
      {data.length === 0 ? (
        <EmptyState
          title="Nenhum dado disponível"
          type="data"
          text="Não há dados para exibir no gráfico."
        />
      ) : (
        <div className="report-widget">
          <div className="report-widget__header">
            <div className="report-widget__inner">
              <h3 className="report-widget__title">Cadastro nas GRE's</h3>
            </div>
            <button
              className="btn btn--outline"
              disabled={data.length === 0}
              onClick={() => setSortDirection(sortDirection === 'desc' ? 'asc' : 'desc')}
            >
              {' '}
              <FiChevronDown
                className="w-6 h-6"
                style={{ transform: sortDirection === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
              />
              Ordenar pelo {sortDirection === 'desc' ? 'menor' : 'maior'}
            </button>
          </div>

          <div className="report-widget__body">
            <PieChart
              data={sorted}
              filters={filters}
              institutions={institutions}
            />
          </div>
        </div>
      )}
    </>
  );
}
